import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./components/auth/Login";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import { ToastContainer } from "./components/ui/ToastContainer";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";

const Dashboard = React.lazy(() => import("./pages/Dashboard").then(m => ({ default: m.Dashboard })));
const AnnouncementManagement = React.lazy(() => import("./pages/AnnouncementManagement").then(m => ({ default: m.AnnouncementManagement })));
const AppVersionManagement = React.lazy(() => import("./pages/AppVersionManagement").then(m => ({ default: m.AppVersionManagement })));
const CareSetupManagement = React.lazy(() => import("./pages/CareSetupManagement").then(m => ({ default: m.CareSetupManagement })));
const ContactInfo = React.lazy(() => import("./pages/ContactInfo"));
const FAQManagement = React.lazy(() => import("./pages/FAQManagement").then(m => ({ default: m.FAQManagement })));
const FeedbackManagement = React.lazy(() => import("./pages/FeedbackManagement").then(m => ({ default: m.FeedbackManagement })));
const PrivacyPolicyManagement = React.lazy(() => import("./pages/PrivacyPolicyManagement").then(m => ({ default: m.PrivacyPolicyManagement })));
const ProfileManagement = React.lazy(() => import("./pages/ProfileManagement").then(m => ({ default: m.ProfileManagement })));
const TermsOfUseManagement = React.lazy(() => import("./pages/TermsOfUseManagement").then(m => ({ default: m.TermsOfUseManagement })));
const TopicOfInterestManagement = React.lazy(() => import("./pages/TopicOfInterestManagement").then(m => ({ default: m.TopicOfInterestManagement })));
const UserManagement = React.lazy(() => import("./pages/UserManagement").then(m => ({ default: m.UserManagement })));
const RegisterCareCenter = React.lazy(() => import("./pages/RegisterCareCenter").then(m => ({ default: m.RegisterCareCenter })));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <ToastContainer>
            <Router>
              <div className="App">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/admin/login"
                    element={<Navigate to="/login" replace />}
                  />
                  <Route
                    path="/"
                    element={<Navigate to="/dashboard" replace />}
                  />
                  <Route
                    path="/*"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout />
                      </ProtectedRoute>
                    }
                  >
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="announcements" element={<AnnouncementManagement />} />
                    <Route path="contact-info" element={<ContactInfo />} />
                    <Route path="feedback" element={<FeedbackManagement />} />
                    <Route path="faqs" element={<FAQManagement />} />
                    <Route path="topics" element={<TopicOfInterestManagement />} />
                    <Route path="privacy-policy" element={<PrivacyPolicyManagement />} />
                    <Route path="terms-of-use" element={<TermsOfUseManagement />} />
                    <Route path="profile" element={<ProfileManagement />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="app-version" element={<AppVersionManagement />} />
                    <Route path="care-setup" element={<CareSetupManagement />} />
                    <Route path="care-centers/register" element={<RegisterCareCenter />} />
                    <Route
                      path="*"
                      element={<Navigate to="/dashboard" replace />}
                    />
                  </Route>
                </Routes>
              </div>
            </Router>
          </ToastContainer>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
